import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-minus-icon',
  templateUrl: './code-minus.component.html'
})
export class CodeMinusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
